import localhost from "apis/localhost";
import { GATE_URL_SEGMENT } from "constants/proposals";

import { getOwnerUrl } from "./shared";

// Gate-submit thunks reconnect SSE / drive the gate wizard flow: the caller owns error
// handling (no internal try/catch or job-queue), matching resumeOutline's style.
export const submitGateAnswers =
  (ownerType, ownerId, gate, answers) => async () => {
    const seg = GATE_URL_SEGMENT[gate];
    const url = `${getOwnerUrl(ownerType, ownerId)}/gates/${seg}/answers`;
    const response = await localhost.post(url, { answers });
    return response.data;
  };

export const confirmGate =
  (ownerType, ownerId, gate, structure = null) =>
  async () => {
    const seg = GATE_URL_SEGMENT[gate];
    const url = `${getOwnerUrl(ownerType, ownerId)}/gates/${seg}/confirm`;
    const response = await localhost.post(url, structure ?? undefined);
    return response.data;
  };

export const reExtractRequirements =
  (ownerType, ownerId, reclassify) => async () => {
    const seg = GATE_URL_SEGMENT.REQ_REVIEW;
    const url = `${getOwnerUrl(ownerType, ownerId)}/gates/${seg}/re-extract`;
    const response = await localhost.post(url, { reclassify });
    return response.data;
  };
